const royalMajlis = {
    id: "royal-majlis",
    name: "Royal Majlis",
    ornament: "arch",
    radius: "soft",
    fonts: {
        display: "Italiana",
        heading: "Cinzel",
        body: "EB Garamond",
    },
    colors: {
        bg: "#0e2a24",
        bgAlt: "#14362d",
        surface: "#f7f1e4",
        primary: "#f4ecd8",
        primaryHover: "#fff8ee",
        accent: "#c6a15b",
        accentSoft: "#e4d2a1",
        rose: "#b08968",
        roseDeep: "#8c6244",
        leaf: "#3e8f73",
        text: "#f4ecd8",
        textMuted: "#cbbba4",
        border: "#a08a5c",
        buttonText: "#0e2a24",
    },
};

const cherryBlossom = {
    id: "cherry-blossom",
    name: "Cherry Blossom",
    ornament: "floral",
    radius: "round",
    fonts: {
        display: "Great Vibes",
        heading: "Cormorant Garamond",
        body: "Newsreader",
    },
    colors: {
        bg: "#fff5f7",
        bgAlt: "#fdecef",
        surface: "#fffafb",
        primary: "#3d2c32",
        primaryHover: "#2c1f24",
        accent: "#e7a3b5",
        accentSoft: "#f8dce4",
        rose: "#f0b7c4",
        roseDeep: "#c46d84",
        leaf: "#6e8b74",
        text: "#2c2426",
        textMuted: "#7a656b",
        border: "#f0d5dc",
        buttonText: "#fff5f7",
    },
};

const oliveGrove = {
    id: "olive-grove",
    name: "Olive Grove",
    ornament: "linear",
    radius: "sharp",
    fonts: {
        display: "Fraunces",
        heading: "Fraunces",
        body: "Libre Baskerville",
    },
    colors: {
        bg: "#f7f6f1",
        bgAlt: "#eeede6",
        surface: "#fcfbf7",
        primary: "#1f1f1c",
        primaryHover: "#0f0f0d",
        accent: "#6b7040",
        accentSoft: "#e4e6d2",
        rose: "#d9d3c5",
        roseDeep: "#b9b3a6",
        leaf: "#5c6236",
        text: "#1c1c18",
        textMuted: "#5f5f54",
        border: "#d4d2c6",
        buttonText: "#f7f6f1",
    },
};

const artDecoNight = {
    id: "art-deco-night",
    name: "Art Deco Night",
    ornament: "geometric",
    radius: "sharp",
    fonts: {
        display: "Cinzel",
        heading: "Cinzel",
        body: "Outfit",
    },
    colors: {
        bg: "#121212",
        bgAlt: "#1c1c1c",
        surface: "#1c1b17",
        primary: "#f2ead8",
        primaryHover: "#fff8ee",
        accent: "#d6b25e",
        accentSoft: "#2c281c",
        rose: "#a68b4a",
        roseDeep: "#6e5828",
        leaf: "#8a7d55",
        text: "#f2ead8",
        textMuted: "#c4b8a2",
        border: "#d6b25e",
        buttonText: "#121212",
    },
};

const formalDay = [royalMajlis, cherryBlossom, oliveGrove, artDecoNight];

export default formalDay;
